<template>
  <div>
    <div class="btn-planning">
      <el-button class="default"
                   @click="openSummary"
                 :disabled="!validPlanning">
        ENVIAR PLANIFICACIÓN
      </el-button>
    </div>
    <DialogSummary ref="summary"
                   @sendPlanning="sendPlanning"/>
  </div>
</template>

<script>
import DialogSummary from './Summary.vue';
import { apiRequest } from '../../../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../../../observability/datadogRum';

export default {
  props: {
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    extraData: {
      type: Object,
      default() {
        return [];
      },
    },
    validPlanning: {
      type: Boolean,
      default() {
        return false;
      },
    },
    countSocWithoutSector: {
      type: Number,
      default() {
        return 0;
      },
    },
    historyCode: {
      type: String,
      default: '',
    },
  },
  name: 'PlanningSend',
  components: {
    DialogSummary,
  },
  data() {
    return {
    };
  },
  methods: {
    openSummary() {
      trackBusinessFlow({
        module: 'planning',
        flow: 'planning_v4',
        action: 'summary_opened',
        status: 'success',
        context: {
          sectors_count: this.sectors.length,
        },
      });
      this.$refs.summary.showDialog(this.countSocWithoutSector, this.extraData, this.sectors);
    },
    sendPlanning() {
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'planning',
        flow: 'planning_v4',
        action: 'planning_requested',
        status: 'attempt',
        context: {
          sectors_count: this.planningData.sectors.length,
        },
      });
      apiRequest({
        module: 'planning',
        service: 'planning_v4',
        params: this.planningData,
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Listo',
          message: 'Se ha creado la planificación con éxito',
        });
        this.$emit('success', response.data.planning_tracker);
        this.$refs.summary.closeDialog();
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v4',
          action: 'planning_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            planning_tracker: response.data.planning_tracker,
          },
        });
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas para crear la planificación',
        });
        this.$refs.summary.closeDialog();
        trackBusinessFlow({
          module: 'planning',
          flow: 'planning_v4',
          action: 'planning_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
        });
      });
    },
  },
  computed: {
    planningData() {
      const sectors = this.sectors.slice()
        .filter(s => s.suborders.length > 0)
        .map(s => ({
          id: s.id,
          name: s.name,
          color: s.color,
          suborders: s.suborders,
          region_id: s.region.id,
          localities: s.localities.map(l => l.id),
          vehicle_id: s.vehicles,
          enterprise_id: s.enterprise.id,
          package_types: s.packageTypes.map(l => l.id),
        }));
      return {
        history_code: this.historyCode,
        ct_id: this.extraData.ct.id,
        alg_settings: this.extraData.alg_settings,
        is_ctt: this.extraData.ct.is_ctt,
        time_init: this.extraData.time_init,
        time_finish: this.extraData.time_finish,
        travel_type_id: this.extraData.travel_type.id,
        sectors,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-planning {
    text-align: right;
    margin: 30px 0 20px 0;
    .el-button { width: 250px; }
  }
</style>
